import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { CoinPackageScreen } from '@/feature/account-details-sweeps/screens/CoinPackageScreen';
import { AddDebitCardWebView } from '@/feature/deposit/screens/AddDebitCardWebView';
import { DepositScreen } from '@/feature/deposit/screens/Deposit';
import { DepositExpiryUpdate } from '@/feature/deposit/screens/DepositExpiryUpdate';
import { DepositMethodWebView as DepositMethodWebViewModal } from '@/feature/deposit/screens/DepositMethodWebView';
import { DepositSalvage } from '@/feature/deposit/screens/DepositSalvage';
import { DepositStatus as DepositStatusModal } from '@/feature/deposit/screens/DepositStatus';
import { FailedDeposit as FailedDepositModal } from '@/feature/deposit/screens/FailedDeposit';
import { FantasyMoneyDepositScreen } from '@/feature/deposit/screens/FantasyMoneyDepositScreen';
import { MazoomaDepositWebView as MazoomaDepositWebViewModal } from '@/feature/deposit/screens/MazoomaDepositWebView';
import { PayByBankDepositWebView as PayByBankDepositWebViewModal } from '@/feature/deposit/screens/PayByBankDepositWebView';
import { SocialWalletDepositScreen } from '@/feature/deposit/screens/SocialWalletDepositScreen';
import { SuccessfulDeposit as SuccessfulDepositModal } from '@/feature/deposit/screens/SuccessfulDeposit';
import { TrustlyDepositScreen } from '@/feature/deposit/screens/TrustlyDepositScreen';
import { TrustlyFundsGuidance } from '@/feature/deposit/screens/TrustlyFundsGuidance';
import { VenmoDepositScreen } from '@/feature/deposit/screens/VenmoDepositScreen';
import { VerifyingDebitDeposit } from '@/feature/deposit/screens/VerifyingDebitDeposit';
import { DepositStackParamList } from '@/navigation/types';
import { common } from '@/styles/styles';

import { screenPresets } from '../screen-presets';

const Stack = createNativeStackNavigator<DepositStackParamList>();

export const DepositStack = () => (
    <SafeAreaProvider style={common.flex}>
        <Stack.Navigator screenOptions={screenPresets.modalStack}>
            <Stack.Screen name="DepositScreen" component={DepositScreen} />
            <Stack.Screen name="CoinPackageScreen" component={CoinPackageScreen} />
            <Stack.Screen
                name="SuccessfulDepositModal"
                component={SuccessfulDepositModal}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="FailedDepositModal"
                component={FailedDepositModal}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen name="AddDebitCardWebView" component={AddDebitCardWebView} />
            <Stack.Screen
                name="DepositMethodWebViewModal"
                component={DepositMethodWebViewModal}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="MazoomaDepositWebViewModal"
                component={MazoomaDepositWebViewModal}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen name="PayByBankDepositWebViewModal" component={PayByBankDepositWebViewModal} />
            <Stack.Screen
                name="VenmoDepositScreen"
                component={VenmoDepositScreen}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="TrustlyDepositScreen"
                component={TrustlyDepositScreen}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="TrustlyFundsGuidance"
                component={TrustlyFundsGuidance}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="FantasyMoneyDepositScreen"
                component={FantasyMoneyDepositScreen}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="SocialWalletDepositScreen"
                component={SocialWalletDepositScreen}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="DepositStatusModal"
                component={DepositStatusModal}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="VerifyingDebitDeposit"
                component={VerifyingDebitDeposit}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen name="DepositSalvage" component={DepositSalvage} options={screenPresets.gestureDisabled} />
            <Stack.Screen
                name="DepositExpiryUpdate"
                component={DepositExpiryUpdate}
                options={screenPresets.gestureDisabled}
            />
        </Stack.Navigator>
    </SafeAreaProvider>
);
